/**
 * @memberof SharedComponents
 * @classdesc Mapping for custom element classes and tag names.
 * @class TagRegistry
 * @alias tagRegistry
 */
export class TagRegistry {
    tagRegistryMap = new Map<CustomElementConstructor, string>();

    /**
     * Gets tagName from element class
     * @param {UIElement} element
     * @returns {string | undefined}
     */
    get(element: CustomElementConstructor): string | undefined {
        return this.tagRegistryMap.get(element);
    }

    /**
     * Gets all registered tag names
     * @returns {Array<string>} All registered tag names (except for charts)
     */
    getAll(): Array<string> {
        return Array.from(this.tagRegistryMap.values());
    }

    /**
     * Sets tagName to registry from element class
     * @param {CustomElementConstructor} element
     * @param {string} tagName
     */
    set(element: CustomElementConstructor, tagName: string) {
        this.tagRegistryMap.set(element, tagName);
    }
}

export const tagRegistry = new TagRegistry();
